import React from 'react';
import { useAuth } from '../context/AuthContext';
import { resumenSuscripcion } from '../services/membresiaService';
import { fechaEliminacion } from '../services/cuentaService';
import { EN_TIENDA, segunTienda } from '../utils/tienda';

// Franja superior con el estado de la membresía: días de prueba que quedan,
// pago por vencer o cuenta pausada (solo lectura). Lleva a "Mi plan".
export default function AvisoMembresia({ onVerPlanes, onVerCuenta }) {
  const { suscripcion } = useAuth();
  if (!suscripcion) return null;

  // Eliminación solicitada: aviso propio, con el camino para cancelarla.
  if (suscripcion.eliminacion_solicitada_en) {
    const dia = fechaEliminacion(suscripcion.eliminacion_solicitada_en).toLocaleDateString('es-HN', { day: 'numeric', month: 'long' });
    return (
      <div style={{ background: '#FEF2F2', border: '1px solid #FCA5A5', color: '#991B1B', borderRadius: '12px', padding: '10px 14px', margin: '14px 26px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px', flexWrap: 'wrap', fontSize: '14px' }}>
        <span>🗑️ <b>Tu cuenta se eliminará el {dia}.</b> Está en pausa hasta entonces. ¿Cambiaste de opinión?</span>
        <button onClick={onVerCuenta} className="k-btn-ghost" style={{ background: '#fff' }}>Cancelar la eliminación</button>
      </div>
    );
  }
  const r = resumenSuscripcion(suscripcion);

  let estilo = null;
  let texto = null;
  if (r.estado === 'pausada') {
    estilo = { background: '#FEF2F2', border: '1px solid #FCA5A5', color: '#991B1B' };
    texto = <>⏸️ <b>Tu cuenta está pausada.</b> Puedes ver tu información, pero no guardar cambios. Tus datos están a salvo.</>;
  } else if (r.estado === 'prueba') {
    estilo = { background: '#F5F3FF', border: '1px solid #C4B5FD', color: '#4C1D95' };
    texto = r.diasRestantes <= 1
      ? <>⏳ <b>Tu prueba gratis termina hoy.</b>{segunTienda(' Elige un plan para seguir trabajando sin pausas.', '')}</>
      : <>🎁 Estás en tu <b>prueba gratis</b>: te quedan <b>{r.diasRestantes} días</b>.</>;
  } else if (r.estado === 'gracia' || (r.estado === 'activa' && r.diasRestantes != null && r.diasRestantes <= 3)) {
    estilo = { background: '#FFFBEB', border: '1px solid #FCD34D', color: '#92400E' };
    texto = <>🔔 Tu plan vence {r.estado === 'gracia' ? 'ya' : `en ${r.diasRestantes} días`}.{segunTienda(' Renueva para no pausar tu cuenta.', '')}</>;
  }
  if (!texto) return null;

  return (
    <div style={{ ...estilo, borderRadius: '12px', padding: '10px 14px', margin: '14px 26px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px', flexWrap: 'wrap', fontSize: '14px' }}>
      <span>{texto}</span>
      {!EN_TIENDA && <button onClick={onVerPlanes} className="k-btn-ghost" style={{ background: '#fff' }}>Ver planes</button>}
    </div>
  );
}
